import React from 'react';

import { FaCheck } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import { Link } from 'gatsby';
import serviceOne from '../images/service1.png';
import serviceTwo from '../images/service2.png';
import Zoom from 'react-reveal/Zoom';
import Bounce from 'react-reveal/Bounce';
import { solutions } from '../data/whyUs';
import { AiOutlineArrowRight } from 'react-icons/ai';

function FeaturedServices() {
  return (
    <div className='py-5 featured-service'>
      <div className='container' style={{ paddingTop: '3rem' }}>
        <div className='row'>
          <div className='col-md-6 pl-3'>
            <h4 className='title'>GREEN PARTNERSHIP</h4>
            <Zoom left>
              <h2 className='subtitle'>We are one-stop-solution provider</h2>
            </Zoom>
            <div className='cards'>
              {solutions.map((sol, i) => {
                return (
                  <div className='card' key={i}>
                    <div className='icon'>
                      <FaCheck className='icon-text' />
                    </div>
                    <Bounce left>
                      <div className='content'>
                        <h3 className='card-title'>{sol}</h3>
                      </div>
                    </Bounce>
                  </div>
                );
              })}
            </div>
            <Link to='/solutions' className='more-container my-4' style={{ marginLeft: '3rem' }}>
              Know More
              <AiOutlineArrowRight className='icon' />
            </Link>
          </div>
          <div className='col-md-6'>
            <h4 className='topText'>Choose your preferred Procurement Plan</h4>
            <div className='row modules'>
              <div className='col-md-6 p-0'>
                <div className='partOne'>
                  <div className='bgContainer'>
                    <Bounce right>
                      <h2>CapEx Model</h2>
                    </Bounce>
                    <Link to='/solutions'>
                      <FiPlus className='plus' />
                    </Link>
                  </div>
                  <img src={serviceOne} alt='' />
                </div>
              </div>
              <div className='col-md-6 p-0'>
                <div className='partTwo'>
                  <img src={serviceTwo} alt='' />
                  <div className='bgContainer'>
                    <Bounce right>
                      <h2>OpEx Model</h2>
                    </Bounce>
                    <Link to='/solutions'>
                      <FiPlus className='plus' />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <p className='bottomText'>
              All functions including chain, value chain, project scheduling, manufacturing, services and spares,
              technology, R&D, etc. are integrated to give a complete solutions package.
            </p>
          </div>
        </div>
        <div id='commitment'></div>
      </div>
    </div>
  );
}

export default FeaturedServices;
